import { useEffect } from 'react';

export function useDisableRightClick() {
  useEffect(() => {
    const handle = (e: any) => e.preventDefault();
    document.addEventListener('contextmenu', handle);
    return () => document.removeEventListener('contextmenu', handle);
  }, []);
}
